// 到店礼
export const PRIVILEGE_GIFT = 1

// 咨询礼
export const PRIVILEGE_CONSULT_GIFT = 32

// 商家承诺
export const PRIVILEGE_MERCHANT_PROMISE = 5

// 订单可退
export const PRIVILEGE_ORDER_REFUND = 6

// 套餐热标
export const PRIVILEGE_HOT_TAG = 17

// 优惠券
export const PRIVILEGE_COUPON = 20

// 轻松聊
export const PRIVILEGE_EASY_CHAT = 30
